import { render, staticRenderFns } from "./VehicleList.vue?vue&type=template&id=f2b0e7b4&scoped=true"
import script from "./VehicleList.vue?vue&type=script&lang=js"
export * from "./VehicleList.vue?vue&type=script&lang=js"
import style0 from "./VehicleList.vue?vue&type=style&index=0&id=f2b0e7b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b0e7b4",
  null
  
)

export default component.exports